import { useCallback, useRef, useState } from 'react';
import { get } from 'lodash';
import { useDispatch } from 'react-redux';

import { editField } from '../../actions/take-off';
import { dataBufferToObjectURL, dataURItoBuffer } from '../../service/ImageUtils';
import { useCanvasResize } from './useCanvasResize';
import { useSignature } from './useSignature';
import { useRefueling } from './useRefueling';

export const useSignaturePopup = (onClose, onSign, signComment, ofpId) => {
    const dispatch = useDispatch();

    const [comment, setComment] = useState(signComment);

    const { signature, signatureEmpty, handleSetSignature, handleUpdateActions, handleClearSignature } = useSignature();

    const { refueling, errorText, handleRefuelingChange, handleInputFocus } = useRefueling();

    const commentRef = useRef();

    const handleSign = useCallback(() => {
        const dataimg = signature.toDataURL('image/png');
        const byteCharacters = dataURItoBuffer(dataimg);
        const preview = dataBufferToObjectURL(byteCharacters, byteCharacters.contentType);
        if (ofpId) {
            dispatch(editField('decisionFuel', +refueling));
        }

        onSign(
            {
                data: byteCharacters.data,
                contentType: byteCharacters.contentType,
                preview: preview,
            },
            get(commentRef, 'current.value')
        );

        onClose();
    }, [commentRef, signature, refueling, ofpId]);

    const handleClose = useCallback(() => {
        setComment('');
        onClose();
    }, []);

    const handleCommentChange = useCallback((event) => setComment(event.target.value), []);

    useCanvasResize(signature);

    return {
        comment,
        commentRef,
        signature,
        signatureEmpty,
        refueling,
        errorText,
        handleRefuelingChange,
        handleInputFocus,
        handleClearSignature,
        handleSign,
        handleClose,
        handleCommentChange,
        handleSetSignature,
        handleUpdateActions,
    };
};
